import service from "@irati/utils/tracking/index"

/**
 * @param {object} -
 * This object will be used for shared functionality
 * We will be able to funnel the context for these events: i.e. survey / driver
 * View questions / comments
 */
const tracking = {}

tracking.viewQuestionsResponses = () => {
  service.trackInsightsEvent("view_questions_responses")
}

tracking.viewComments = () => {
  service.trackInsightsEvent("view_comments")
}

export default tracking
